import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ServiceAgreementV2 } from '../views/PrivateBanking/eBankingTempTypes';

interface PrivateBankingState {
  selectedPBProduct: ServiceAgreementV2 | null;
}

const initialState: PrivateBankingState = {
  selectedPBProduct: null,
};

const privateBankingSlice = createSlice({
  name: 'privateBanking',
  initialState,
  reducers: {
    setSelectedPBProduct(state, action: PayloadAction<ServiceAgreementV2 | null>) {
      state.selectedPBProduct = action.payload;
    },
    clearSelectedPBProduct(state) {
      state.selectedPBProduct = null;
    },
  },
});

export const { setSelectedPBProduct, clearSelectedPBProduct } = privateBankingSlice.actions;
export default privateBankingSlice.reducer;

export const selectSelectedPBProduct = (state: { privateBanking: PrivateBankingState }) =>
  state.privateBanking.selectedPBProduct;
